import { SP_QueryStudentViewer_studentViewer } from '~graphql/__generated__/SP_QueryStudentViewer';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const REMOVE_USER_INFO = 'REMOVE_USER_INFO';
export const UPDATE_LOADED = 'UPDATE_LOADED';
interface UpdateUserInfoAction {
  type: typeof UPDATE_USER_INFO | typeof REMOVE_USER_INFO | typeof UPDATE_LOADED;
  viewer: SP_QueryStudentViewer_studentViewer;
}
export type UserActionTypes = UpdateUserInfoAction;
